module.exports = "<div class=\"layout-wrapper layout-static-inactive layout-candidate\" (click)=\"app.onLayoutClick()\">\n\n  <app-topbar></app-topbar>\n  <div class=\"layout-content\">\n\n      <app-breadcrumb></app-breadcrumb>\n\n      <div class=\"layout-content-container\">\n        <router-outlet></router-outlet>\n      </div>\n\n      <app-footer></app-footer>\n  </div>\n  <ngx-spinner bdColor = \"rgba(51, 51, 51, 0.8)\" size = \"medium\" color = \"#fff\" type = \"ball-atom\" ></ngx-spinner>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/candidate/candidate.component.html
// module id = ./src/app/candidate/candidate.component.html
// module chunks = main